// extracted by mini-css-extract-plugin
module.exports = {"colBtn":"FormModal_colBtn__2Am2r","formModal":"FormModal_formModal__6V2oX","empty":"FormModal_empty__36Wcf"};